/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Keen_Seal_DashInputs */

const en_warm_keen_seal_dash = /** @type {(inputs: Warm_Keen_Seal_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KPI-level minimum answers`)
};

const de_warm_keen_seal_dash = /** @type {(inputs: Warm_Keen_Seal_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestantworten pro KPI`)
};

/**
* | output |
* | --- |
* | "KPI-level minimum answers" |
*
* @param {Warm_Keen_Seal_DashInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_keen_seal_dash = /** @type {((inputs?: Warm_Keen_Seal_DashInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Keen_Seal_DashInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_keen_seal_dash(inputs)
	return de_warm_keen_seal_dash(inputs)
});